import DataTable from '@components/DataTable';

interface DataStatusProps {
  lastAnalysisUpdateFormattedUTC: string;
  lastAnnualEarninsUpdateFormattedUTC: string;
  lastEarningsUpdateFormattedUTC: string;
  lastEstimatesConfirmationFormattedUTC: string;
  lastEODPriceUpdateFormattedUTC: string;
}

const DataStatus = ({
  lastAnalysisUpdateFormattedUTC,
  lastAnnualEarninsUpdateFormattedUTC,
  lastEarningsUpdateFormattedUTC,
  lastEstimatesConfirmationFormattedUTC,
  lastEODPriceUpdateFormattedUTC,
}: DataStatusProps) => (
  <>
    <DataTable>
      <caption>
        All financial data provided by Standard &amp; Poor's Capital IQ.
      </caption>
      <thead>
        <tr>
          <th>Data</th>
          <th>Last Updated (UTC time)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Company Analysis</td>
          <td>{lastAnalysisUpdateFormattedUTC}</td>
        </tr>
        <tr>
          <td>End of Day Share Price</td>
          <td>{lastEODPriceUpdateFormattedUTC}</td>
        </tr>
        {lastEstimatesConfirmationFormattedUTC !== 'N/A' && (
          <tr>
            <td>Estimates</td>
            <td>{lastEstimatesConfirmationFormattedUTC}</td>
          </tr>
        )}
        <tr>
          <td>Earnings</td>
          <td>{lastEarningsUpdateFormattedUTC}</td>
        </tr>
        <tr>
          <td>Annual Earnings</td>
          <td>{lastAnnualEarninsUpdateFormattedUTC}</td>
        </tr>
      </tbody>
    </DataTable>
    <br />
    <br />
    <p>
      <span>
        {`Unless specified all financial data is based on a yearly period but updated quarterly. This is known as Trailing Twelve Month (TTM) or Last Twelve Month (LTM) Data. Learn more `}
      </span>
      <a
        href="/help/articles/hc/en-us/articles/115006170908-Why-is-some-of-the-data-on-Simply-Wall-St-different-to-other-sites-"
        rel="nofollow noreferrer noopener"
        target="_blank"
      >
        here
      </a>
      .
    </p>
  </>
);

export default DataStatus;
